module.exports = __webpack_public_path__ + "img/register-trans.12bb80da.png";